import { useStore } from "zustand";
import { coreStore } from "@/lib/stores/core-store";
import { uiStore } from "@/lib/stores/ui-store";

export function useIsSharedWorkspace(): boolean {
	const workspaceId = useStore(uiStore, (state) => state.currentWorkspaceId);
	return useStore(coreStore, (state) =>
		workspaceId
			? Boolean(state.workspaces.get(workspaceId)?.hostOrganization)
			: false
	);
}
